import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const UserNotInOrganizationError = BaseErrorSchema.extend({
  errorType: z.literal('UserNotInOrganizationError'),
  id: z.string(),
});

export type UserNotInOrganizationError = z.infer<
  typeof UserNotInOrganizationError
>;
